import { IconMaterial } from '@abyss/web/ui/IconMaterial';
import { Link } from '@abyss/web/ui/Link';
import React from 'react';

type Props = {
  refreshUrl?: string;
  buttonText: string;
};

export const ErrorRefreshButton = ({
  refreshUrl = '/findcare',
  buttonText,
}: Props) => {
  return (
    <Link
      after={<IconMaterial icon="refresh" />}
      color="$accent1"
      data-auto-testid="reload-link"
      data-testid="reload-link"
      fontWeight="$bold"
      href={refreshUrl}
      size="$sm"
      role="button"
      style={{
        marginTop: 'var(--abyss-space-md)',
      }}
    >
      {buttonText}
    </Link>
  );
};
